import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from "@learn-me/ui";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { ArrowLeft } from "lucide-react";
import type { ForgotPasswordRequest } from "@learn-me/types";

export default function ForgotPasswordPage() {
  const { forgotPassword, forgotPasswordLoading } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordRequest>();

  const onSubmit = (data: ForgotPasswordRequest) => {
    forgotPassword(data);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-12 px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <h1 className="text-2xl font-bold">Recuperar Contrasena</h1>
          <p className="text-muted-foreground">
            Ingresa tu correo y te enviaremos instrucciones
          </p>
        </CardHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <CardContent className="space-y-4">
            <Input
              label="Correo electronico"
              type="email"
              placeholder="tu@email.com"
              error={errors.email?.message}
              {...register("email", {
                required: "El correo es requerido",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Correo invalido",
                },
              })}
            />
          </CardContent>
          <CardFooter className="flex flex-col gap-4">
            <Button
              type="submit"
              className="w-full"
              isLoading={forgotPasswordLoading}
            >
              Enviar Instrucciones
            </Button>
            <Link
              to="/login"
              className="flex items-center justify-center gap-2 text-sm text-muted-foreground hover:text-foreground"
            >
              <ArrowLeft className="h-4 w-4" />
              Volver al login
            </Link>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
